import React, { memo, forwardRef } from "react";
const SvgCurlybrackets1 = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        stroke="#717171"
        strokeWidth={0.2}
        d="M15.403 25.658h0l-.003.004c-.209.338-.6.52-1.211.52h-.54c-.283 0-.514.064-.674.208-.163.146-.236.36-.236.621s.073.475.236.621c.16.145.391.208.674.208h.675c1.147 0 2.015-.273 2.581-.839.568-.549.84-1.437.84-2.636v-4.536c0-.966.117-1.677.34-2.142.24-.461.614-.777 1.13-.949.271-.084.485-.207.631-.373a.899.899 0 00.221-.613.899.899 0 00-.22-.613c-.147-.166-.36-.289-.632-.373a1.893 1.893 0 01-1.13-.949c-.223-.465-.34-1.176-.34-2.142V7.139c0-1.2-.272-2.087-.84-2.636-.566-.566-1.434-.839-2.581-.839h-.675c-.283 0-.514.063-.674.208-.163.146-.236.36-.236.621s.073.475.236.621c.16.145.391.208.674.208h.54c.611 0 1.002.182 1.211.52h0l.003.004c.234.335.36.868.36 1.617v4.617c0 1.03.203 1.863.617 2.492.373.566.913.958 1.613 1.18-.7.222-1.24.614-1.613 1.18-.414.63-.617 1.463-.617 2.492v4.617c0 .749-.126 1.282-.36 1.617z"
      />
    </svg>
  );
});
SvgCurlybrackets1.displayName = "SvgCurlybrackets1";
const MemoForwardRef = memo(SvgCurlybrackets1);
export default MemoForwardRef;
